<template lang="pug">
div
  input(
    type="file"
    ref="geotiffFile"
    hidden
    @change="onFileChange"
    accept="image/tiff,.tif")
  lf-control-action(
    icon="mdi-file-image-marker-outline"
    dense
    title="Cargar TIFF (Georeferenciado EPSG:4326)"
    @click="loadImage()"
  )
</template>

<script>
import { mapState } from 'vuex';
import GeoRasterLayer from 'georaster-layer-for-leaflet';
import parseGeoraster from 'georaster';
import LfControlAction from '@/components/geos/LfControlAction.vue';

export default {
  name: 'LoadGeotiffControl',

  components: {
    LfControlAction
  },

  props: {},

  emits: [],

  data() {
    return {};
  },

  computed: {
    ...mapState('module', []),
  },

  mounted() {},

  methods: {
    loadImage() {
      this.$refs.geotiffFile.click();
    },
    findLayerControl() {
      let p = this.$parent;
      while (p) {
        if (p.$refs && p.$refs.lyControl) {
          return p.$refs.lyControl.mapObject;
        }
        p = p.$parent;
      }
      return null;
    },
    // Evento para cargar el tiff al mapa Leaflet
    onFileChange(ev) {
      if (ev) {
        this.$nextTick(() => {
          const map = this.$parent.mapObject;
          const layerControl = this.findLayerControl();
          const file = ev.target.files[0];
          const reader = new FileReader();
          reader.readAsArrayBuffer(file);
          reader.onloadend = () => {
            const arrayBuffer = reader.result;
            parseGeoraster(arrayBuffer).then((georaster) => {
              const layer = new GeoRasterLayer({
                georaster,
                opacity: 1,
                resolution: 256
              });
              layer.addTo(map);
              map.fitBounds(layer.getBounds());
              // agregar la capa a los controles
              layerControl.addOverlay(layer, file.name);
            });
          };
        });
      }
    },
  }
};
</script>

<style scoped>
</style>
